import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center flex-wrap dialog-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_header_action = _resolveComponent("ontos-header-action")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_ontos_unsaved_changes_dialog = _resolveComponent("ontos-unsaved-changes-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.fullPageRoute || _ctx.onFullPage)
      ? (_openBlock(), _createBlock(_component_ontos_header_action, {
          key: 0,
          icon: "mdi-open-in-new",
          label: _ctx.$tt('expand'),
          disabled: _ctx.disabled,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.leave('full-page')))
        }, null, 8, ["label", "disabled"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_btn, {
      size: "small",
      variant: "text",
      icon: "",
      title: _ctx.$tt(_ctx.back ? 'back' : 'close'),
      disabled: _ctx.disabled,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.leave(_ctx.back ? 'back' : 'close')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.back ? 'mdi-arrow-left' : 'mdi-close'), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "disabled"]),
    _createVNode(_component_ontos_unsaved_changes_dialog, {
      leaving: _ctx.leaving,
      onConfirmed: _ctx.confirmLeave,
      onCancelled: _cache[2] || (_cache[2] = ($event: any) => (_ctx.leaving = null))
    }, null, 8, ["leaving", "onConfirmed"])
  ]))
}